<div
  class="d-flex flex-column align-items-center justify-content-center gap-3 px-4"
>
  <div
    class="d-flex align-items-center justify-content-center gap-2 align-self-end"
  >
    <i-feather class="p-0 m-0" name="eye"></i-feather>
    <p class="m-0 p-0 references-text">
      Accès aux
      <a class="references-link" (click)="redirectToReferencesOnClick()"
        >références achetées</a
      >
    </p>
  </div>
  <form
    id="votre-estimation-form"
    class="w-100"
    [formGroup]="votreEstimationForm"
  >
    <div class="mb-3">
      <p-textarea
        [formControl]="this.votreEstimationForm.controls.comment"
        id="comment"
        name="comment"
        label="Commentaire"
        [maxLength]="2500"
        [showCounter]="true"
        (input)="commentChanged($event)"
      ></p-textarea>
    </div>
    <div class="mb-3 w-50">
      <p-input
        [formControl]="this.votreEstimationForm.controls.chosenValue"
        id="chosen-value"
        name="chosen-value"
        label="Valeur précise"
        type="number"
        (input)="chosenValueChanged($event)"
        fixedText="€"
      ></p-input>
    </div>
    <div class="mb-3 w-50">
      <p-input
        [formControl]="this.votreEstimationForm.controls.chosenLowValue"
        id="chosen-low-value"
        name="chosen-low-value"
        label="Estimation Basse"
        type="number"
        (input)="chosenLowValueChanged($event)"
        fixedText="€"
      ></p-input>
    </div>
    <div class="mb-3 w-50">
      <p-input
        [formControl]="this.votreEstimationForm.controls.chosenHighValue"
        id="chosen-high-value"
        name="chosen-high-value"
        label="Estimation Haute"
        fixedText="€"
        type="number"
        (input)="chosenHighValueChanged($event)"
      ></p-input>
    </div>
    <div class="mb-3">
      <p-textarea
        [formControl]="this.votreEstimationForm.controls.conclusion"
        id="conclusion"
        name="conclusion"
        label="Conclusion"
        [maxLength]="2500"
        [showCounter]="true"
        (input)="conclusionChanged($event)"
      ></p-textarea>
    </div>
  </form>
</div>
